module.exports = __webpack_public_path__ + "84736a8bfb72c385231993437fd8b90e.svg";